import {loadImage} from '@wix/music-shared/dist/src/utils/loadImage/loadImage';
import {injectable, decorate} from 'inversify';
import {IImageUtils} from './IImageUtils';

export class ImageUtils implements IImageUtils {
  loadImage(src: string): Promise<void> {
    return loadImage(src);
  }
}

decorate(injectable(), ImageUtils);
